import script from "./RecurrenceModal.vue?vue&type=script&setup=true&lang=js"
export * from "./RecurrenceModal.vue?vue&type=script&setup=true&lang=js"

import "./RecurrenceModal.vue?vue&type=style&index=0&id=10ee9c04&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10ee9c04"]])

export default __exports__